import type { CropValue } from "@common/types/CropValue";
import type { CropValuesParams } from "@shared/api";
import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { apiClient } from "apiClient";

export const CROP_VALUES_QUERY_KEY = ["cropValues"] as const;

type Params<TData = { items: CropValue[] }> = Pick<
  UseQueryOptions<{ items: CropValue[] }, Error, TData>,
  "enabled" | "select"
> & {
  queryParams?: CropValuesParams;
};

const useCropValuesQuery = <TData = { items: CropValue[] }>({
  queryParams,
  ...options
}: Params<TData> = {}) =>
  useQuery({
    queryKey: ["cropValues", queryParams],
    queryFn: () => apiClient.cropValues.fetchCropValues(queryParams),
    ...options
  });

export const useSuspenseCropValuesQuery = <TData = { items: CropValue[] }>({
  queryParams,
  ...options
}: Params<TData> = {}) =>
  useSuspenseQuery({
    queryKey: ["cropValues", queryParams],
    queryFn: () => apiClient.cropValues.fetchCropValues(queryParams),
    ...options
  });

export default useCropValuesQuery;
